import {
    PAGE_DELETED,
    PAGE_DELETING,
    PAGE_DOWNLOADED,
    PAGE_EDITING,
    PAGE_FAILED,
    PAGES_PENDING,
    PAGE_POSTING,
    PAGE_RESET,
    PAGES_DOWNLOADED,
    PAGES_FAILED,
    PAGES_RESET,
    PAGE_FOCUS,
    PAGE_MEDIA_DELETED,
    PAGE_MEDIA_DELETING,
    PAGE_MEDIA_FAILED,
    PAGE_MEDIA_FOCUS,
    PAGE_MEDIA_UPLOADED,
    PAGE_MEDIA_UPLOADING,
} from './types';

import LangService from '../../services/lang';

export const INITIAL_STATE = {
    error: null,
    content: LangService.defaultTranslatedContent,
    deletingMedia: false,
    pending: false,
    sending: false,
    currentIndex: null,
    currentPage: null,
    currentMedia: null,
    pendingMedias: [],
    uploadedMedias: [],
    failedMedias: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case PAGES_RESET:
            return INITIAL_STATE;
        case PAGE_RESET:
            return {
                ...state,
                error: null,
                sending: false,
                currentIndex: 0,
                currentPage: null,
            };
        case PAGE_POSTING:
            return {
                ...state,
                sending: true,
            };
        case PAGE_EDITING:
            return {
                ...state,
                sending: true,
            };
        case PAGE_DELETING:
            return {
                ...state,
                sending: true,
            };
        case PAGE_DELETED:
            let newState = {
                ...state,
                sending: false,
            };

            LangService.langs.forEach(function (l) {
                if (newState.content[l.key] !== undefined) {
                    newState.content[l.key] = state.content[l.key].filter((page) => {
                        return page.id !== action.payload.id;
                    });
                }
            });

            if (state.currentPage) {
                if (state.currentPage.id === action.payload.id) {
                    newState.currentPage = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content[action.payload.lang].findIndex((page) => {
                        return newState.currentPage.id === page.id;
                    });
                }
            }

            return newState;
        case PAGES_PENDING:
            return {
                ...state,
                pending: true,
            };
        case PAGES_DOWNLOADED:
            let newContentPages = { ...state.content };
            newContentPages[action.payload.lang] = action.payload.pages;
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContentPages,
            };
        case PAGE_DOWNLOADED:
            let newIndex;
            let id = action.payload.page.id;
            let page = state.content[action.payload.lang].find(function (page) {
                return page.id === id;
            });
            let newContent = { ...state.content };
            if (page) {
                let index = state.content[action.payload.lang].findIndex((statePage) => {
                    return statePage.id === page.id;
                });
                newContent[action.payload.lang][index] = action.payload.page;
                newIndex = index;
            } else {
                newContent[action.payload.lang] = [
                    ...state.content[action.payload.lang],
                    action.payload.page,
                ];
                newIndex = newContent[action.payload.lang].length - 1;
            }
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentPage: action.payload.page,
                currentIndex: newIndex,
            };
        case PAGE_FAILED:
            return {
                ...state,
                deletingMedia: false,
                pending: false,
                sending: false,
                error: action.payload,
                currentPage: null,
                currentIndex: 0,
            };
        case PAGE_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content[action.payload.lang].findIndex(page => {
                    return page.id === action.payload.page.id;
                }),
                currentPage: action.payload.page,
            };
        case PAGES_FAILED:
            return {
                ...state,
                pending: false,
                error: action.payload,
            };
        case PAGE_MEDIA_FOCUS:
            return {
                ...state,
                error: null,
                pending: false,
                currentMedia: action.payload,
            };
        case PAGE_MEDIA_UPLOADING:
            return {
                ...state,
                pendingMedias: [
                    ...state.pendingMedias,
                    action.payload,
                ],
                sending: true,
            };
        case PAGE_MEDIA_UPLOADED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload;
                }),
                uploadedMedias: [
                    ...state.uploadedMedias,
                    action.payload,
                ],
                sending: false,
                currentMedia: action.payload,
            };
        case PAGE_MEDIA_FAILED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload;
                }),
                failedMedias: [
                    ...state.failedMedias,
                    action.payload,
                ],
                currentMedia: action.payload,
            };
        case PAGE_MEDIA_DELETING:
            return {
                ...state,
                deletingMedia: true,
            };
        case PAGE_MEDIA_DELETED:
            const pageMediaDeleted = { ...state.currentPage };
            pageMediaDeleted.medias = pageMediaDeleted.medias.filter((media) => media.id !== action.payload);

            return {
                ...state,
                deletingMedia: false,
                currentPage: pageMediaDeleted,
                currentMedia: null,
            };
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// src/store/pages/reducers.js